import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { products } from '../../data/products';
import { images } from '../../data/images';
import { dec, euro } from '../../utils/format';
export function ProductExplorer() {
  const [activeId, setActiveId] = useState('kluis-10');
  const product = products.find(p => p.id === activeId) ?? products[1];
  const specs = [{
    label: 'Opslagcapaciteit',
    value: `${dec(product.capacity)} kWh`
  }, {
    label: 'Vermogen',
    value: `${product.power} kW`
  }, {
    label: 'Modules',
    value: `${product.modules} × 5,1 kWh`
  }, {
    label: 'Garantie',
    value: '10 jaar / 6.000 cycli'
  }];
  return <section id="producten" className="scroll-mt-20 bg-canvas-deep" data-id="element-198" data-mp="12kw40ovczn8j">
      <div className="mx-auto max-w-[1440px] px-4 py-24 sm:px-6 lg:px-10 lg:py-32" data-id="element-199" data-mp="3re1i85zinnhm">
        <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end" data-id="element-200" data-mp="3nb51ylxg83gu">
          <h2 className="max-w-3xl text-4xl font-semibold leading-[1.04] tracking-tightest text-ink sm:text-5xl lg:text-[56px]" data-id="element-201" data-mp="2jfb40drvaw1g">
            Eén batterij, drie formaten.
            <br className="hidden sm:block" data-id="element-202" data-mp="2ocjlsd93sy26" /> <span className="text-ink-muted" data-id="element-203" data-mp="2afwcrc3vmhfw">Uitbreidbaar wanneer je wilt.</span>
          </h2>
          <p className="max-w-sm text-lg leading-relaxed text-ink-soft" data-id="element-204" data-mp="2eg6rpe9nci6w">
            Modules van 5,1 kWh stapel je op één voet. Begin klein, breid later uit.
          </p>
        </div>

        <div className="mt-14 grid gap-8 overflow-hidden rounded-[28px] bg-canvas lg:grid-cols-2 lg:gap-0" data-id="element-205" data-mp="25frw9m2yxmpo">
          <div className="relative flex min-h-[380px] items-center justify-center bg-canvas lg:min-h-[560px]" data-id="element-206" data-mp="1qrnkl22c2bge">
            <img src={images.product} alt={`${product.name} thuisbatterij`} className="h-full max-h-[560px] w-full object-cover" data-id="element-207" data-mp="1vpgti2v0tjkd" />
            <div className="absolute bottom-6 left-6 flex flex-col-reverse gap-1.5" aria-hidden="true" data-id="element-208" data-mp="1hqz4m1tdq10v">
              {[1, 2, 3].map(m => <span key={m} className={`h-2.5 w-12 rounded-full transition-colors duration-200 ${m <= product.modules ? 'bg-forest-light' : 'bg-line'}`} data-id="element-209" data-mp="3oeg28hzrub9b" />)}
            </div>
          </div>

          <div className="flex flex-col p-6 sm:p-10 lg:p-14" data-id="element-210" data-mp="3ep66ms5pyagg">
            <div role="tablist" aria-label="Kies een formaat" className="grid grid-cols-3 gap-1 rounded-2xl bg-canvas-deep p-1" data-id="element-211" data-mp="3ao49qhz9yahn">
              {products.map(p => <button key={p.id} role="tab" aria-selected={p.id === activeId} onClick={() => setActiveId(p.id)} className={`whitespace-nowrap rounded-xl px-3 py-3 text-[15px] font-medium transition-colors duration-150 ${p.id === activeId ? 'bg-ink text-canvas' : 'text-ink-soft hover:text-ink'}`} data-id="element-212" data-mp="69393f8bm25u">
                  {dec(p.capacity)} kWh
                </button>)}
            </div>

            <AnimatePresence mode="wait" data-id="element-213" data-mp="xhwefibtfeli">
              <motion.div key={product.id} role="tabpanel" initial={{
              opacity: 0,
              y: 6
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -6
            }} transition={{
              duration: 0.18,
              ease: [0.23, 1, 0.32, 1]
            }} className="mt-10 flex flex-1 flex-col" data-id="element-214" data-mp="xes74c3202qm">
                <h3 className="text-5xl font-semibold tracking-tight text-ink" data-id="element-215" data-mp="1g6urnyitg365">{product.name}</h3>
                <p className="mt-3 text-lg text-ink-soft" data-id="element-216" data-mp="1l4cqgw34d20f">{product.tagline}</p>
                <p className="mt-1 text-[15px] text-ink-muted" data-id="element-217" data-mp="1q6lj1rc2y220">{product.bestFor}</p>

                <dl className="mt-8 grid grid-cols-2 gap-x-6 border-t border-line" data-id="element-218" data-mp="1u5udkyey23ym">
                  {specs.map(s => <div key={s.label} className="border-b border-line py-4" data-id="element-219" data-mp="3ry84ldd7d4r3">
                      <dt className="text-[13px] text-ink-muted" data-id="element-220" data-mp="3vza3tu74dgt2">{s.label}</dt>
                      <dd className="mt-0.5 text-[17px] font-medium text-ink" data-id="element-221" data-mp="30niyylpbv63c">{s.value}</dd>
                    </div>)}
                </dl>

                <div className="mt-auto flex flex-col gap-5 pt-10 sm:flex-row sm:items-end sm:justify-between" data-id="element-222" data-mp="2wojn0h56i92e">
                  <div data-id="element-223" data-mp="35n5ex2wjj0fu">
                    <div className="text-[13px] text-ink-muted" data-id="element-224" data-mp="35mnc1nfdhnyy">Vanaf, incl. installatie en btw</div>
                    <div className="text-4xl font-semibold tracking-tight text-ink tabular-nums" data-id="element-225" data-mp="2hx18knrywml5">{euro(product.price)}</div>
                  </div>
                  <Link to="/scan" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-ink px-6 py-4 text-[16px] font-medium text-canvas transition-colors duration-150 hover:bg-forest" data-id="element-226" data-mp="2d0aw0afdg94h">
                    Past deze bij mijn huis?
                    <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-227" data-mp="1u7zx0rnu8vbn" />
                  </Link>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>;
}